import { BatchPurpose } from '@/Domain/Batch/BatchPurpose'
import { BatchSituation } from '@/Domain/Batch/BatchSituation'

export class BatchIntervention {
  private _purpose: BatchPurpose
  private _situation: BatchSituation

  constructor (purpose: BatchPurpose, situation: BatchSituation) {
    this._purpose = purpose
    this._situation = situation
  }

  purpose (): BatchPurpose {
    return this._purpose
  }

  situation (): BatchSituation {
    return this._situation
  }
}
